import BaseNotificationHandler from './baseHandler.js';

/**
 * Repost Notification Handler
 * Handles repost notifications
 */
class RepostHandler extends BaseNotificationHandler {
    getIcon(notification, parsedData) {
        return "🔁";
    }

    getMainText(notification, parsedData) {
        const senderName = this.getSenderInfo(notification, parsedData) || 'Someone';
        return `${senderName} reposted your post`;
    }

    getDetails(notification, parsedData) {
        const details = [];
        return details;
    }

    getThumbnail(notification, parsedData) {
        // For reposts, try to get post image
        if (parsedData.post_image) return parsedData.post_image;
        if (parsedData.image) return parsedData.image;
        if (parsedData.media?.[0]?.url) return parsedData.media[0].url;
        if (parsedData.data?.post_image) return parsedData.data.post_image;
        if (parsedData.data?.image) return parsedData.data.image;
        return super.getThumbnail(notification, parsedData);
    }

    getActionUrl(notification, parsedData) {
        // Check parsedData.action_url first (outer level)
        if (parsedData.action_url) {
            return parsedData.action_url;
        }

        // Check nested data.action_url (from double-encoded JSON)
        if (parsedData.data?.action_url) {
            return parsedData.data.action_url;
        }

        // Check notification.action_url as fallback
        if (notification.action_url) {
            return notification.action_url;
        }

        // Build post URL from post_id if available
        const postId = this.getPostId(notification, parsedData);
        if (postId) {
            return `/post/${postId}`;
        }

        return null;
    }

    /**
     * Get post ID from notification data
     * @param {Object} notification - The notification object
     * @param {Object} parsedData - Parsed notification data
     * @returns {number|null} Post ID or null
     */
    getPostId(notification, parsedData) {
        return parsedData.repost_id || parsedData.data?.repost_id || parsedData.post_id || parsedData.data?.post_id;
    }

    handleClick(notification, parsedData, navigate, onClose, openPostModal = null) {
        if (openPostModal) {
            const postId = this.getPostId(notification, parsedData);
            if (postId) {
                openPostModal(postId);
                if (onClose) onClose();
                return;
            }
        }

        const actionUrl = this.getActionUrl(notification, parsedData);
        if (actionUrl) {
            if (actionUrl.startsWith('http://') || actionUrl.startsWith('https://')) {
                window.location.href = actionUrl;
            } else {
                navigate(actionUrl);
            }
            if (onClose) onClose();
        }
    }
}

export default RepostHandler;
